import { useEffect, useState } from 'react';

import { getCountry } from '@iwIntlProvider/CountryProvider';
import { tracking } from '@iwoca/frontend-tracking-library';
import { IconFileVisualizationFilled } from '@iwoca/icons';
import { Button } from '@iwoca/orion';
import { REQUEST_CHANGE_ROUTER } from '@iwRouter/IwRouter.actions';
import { FormattedMessage, useIntl } from 'react-intl';
import { connect } from 'react-redux';
import { Dispatch } from 'redux';

import messages from './DeferredView.messages';
import styles from './DeferredView.module.css';
import { AMPLITUDE_CATEGORY } from '../../../tracking/amplitudeCategories';
import { AMPLITUDE_EVENT_NAMES } from '../../../tracking/amplitudeEvents';
import { MainSectionWrapper } from '../../pageStructure/mainSectionWrapper';

const mapDispatchToProps = (dispatch: Dispatch) => ({
    redirectToReapplyForm: () =>
        dispatch({
            type: REQUEST_CHANGE_ROUTER,
            location: {
                pathname: '/apply-flexi-loan/'
            }
        })
});

type InjectedProps = ReturnType<typeof mapDispatchToProps>;

const DeferredView = ({ redirectToReapplyForm }: InjectedProps) => {
    const intl = useIntl();
    const [submittingNewApplication, setSubmittingNewApplication] =
        useState(false);

    useEffect(() => {
        tracking.ampli.track({
            event_type: AMPLITUDE_EVENT_NAMES.APPLICATION_ON_HOLD_VIEWED,
            event_properties: {
                category:
                    getCountry() === 'DE'
                        ? AMPLITUDE_CATEGORY.ACCOUNT_PAGES_DE
                        : AMPLITUDE_CATEGORY.ACCOUNT_PAGES
            }
        });
    }, []);

    function reApplyForLoan() {
        setSubmittingNewApplication(true);
        tracking.ampli.track({
            event_type: AMPLITUDE_EVENT_NAMES.APPLICATION_ON_HOLD_CTA_CLICKED,
            event_properties: {
                category:
                    getCountry() === 'DE'
                        ? AMPLITUDE_CATEGORY.ACCOUNT_PAGES_DE
                        : AMPLITUDE_CATEGORY.ACCOUNT_PAGES
            }
        });

        redirectToReapplyForm();
    }

    return (
        <MainSectionWrapper>
            <div className={styles.innerWrapper}>
                <div className={styles.container}>
                    <div className={styles.fileSearchIconContainer}>
                        <IconFileVisualizationFilled
                            className={styles.fileSearchIcon}
                        />
                    </div>
                    <div className={styles.title}>
                        <FormattedMessage {...messages.title} />
                    </div>
                    <div className={styles.subtitle} data-testid="subtitle">
                        <FormattedMessage {...messages.subtitle} />
                    </div>
                    <Button
                        size="large"
                        variant="primary"
                        className={styles.reApplyCTA}
                        data-testid="reapply-cta"
                        loading={submittingNewApplication}
                        onClick={() => reApplyForLoan()}
                    >
                        <FormattedMessage {...messages.reApplyButtonText} />
                    </Button>
                    <div
                        className={styles.underButtonText}
                        data-testid="underButtonText"
                    >
                        <FormattedMessage
                            {...messages.underButtonText}
                            values={{
                                link: (
                                    <a
                                        className={styles.phoneLink}
                                        href={`tel:${intl.formatMessage(
                                            messages.callPhoneNumber
                                        )}`}
                                    >
                                        <FormattedMessage
                                            {...messages.displayPhoneNumber}
                                        />
                                    </a>
                                )
                            }}
                        />
                    </div>
                </div>
            </div>
        </MainSectionWrapper>
    );
};

// eslint-disable-next-line import/no-default-export
export default connect(null, mapDispatchToProps)(DeferredView);
